import React, { useState } from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
// import { User } from 'feather-icons-react';
import Cookies from "universal-cookie";
import CommentScore from "./CommentScore";
import {
  IconComment,
  IconDisLike,
  IconLike,
  IconUser,
  IconUserCustomer,
} from "../../../assets/icons";
import ApiAmusementService from "../../../core/api/api.amusementService";
import { toast } from "react-toastify";

function ModalCommentBox({ testimonials, amusementService }) {
  const cookies = new Cookies();
  const [likeDislikeCounts, setLikeDislikeCounts] = useState({});

  const fnLikeOrDislike = (commentid, likeOrDislike) => async (event) => {
    // بررسی کوکی و درج در کوکی
    let likeOrDislikeOld = cookies.get("amusementTestimoniallike_" + commentid);

    if (likeOrDislikeOld !== likeOrDislike) {
      // به‌روزرسانی کوکی
      cookies.set("amusementTestimoniallike_" + commentid, likeOrDislike, {
        path: "/",
      });

      // افزایش یا کاهش شمارش‌ها
      setLikeDislikeCounts((prevCounts) => {
        const currentCounts = prevCounts[commentid] || {
          likeCount: 0,
          disLikeCount: 0,
        };

        const updatedCounts = {
          likeCount:
            currentCounts.likeCount +
            (likeOrDislike === "Up" ? 1 : likeOrDislikeOld === "Up" ? -1 : 0),
          disLikeCount:
            currentCounts.disLikeCount +
            (likeOrDislike === "Down"
              ? 1
              : likeOrDislikeOld === "Down"
              ? -1
              : 0),
        };

        return { ...prevCounts, [commentid]: updatedCounts };
      });

      // ارسال و درج در دیتا بیس
      let response =
        await ApiAmusementService.updateAmusementTestimonialLikeOrDislike({
          id: commentid,
          likeOrDislikeOld: likeOrDislikeOld,
          likeOrDislike: likeOrDislike,
        });

      // بررسی پاسخ و نمایش پیام
      if (response && response.message) {
        toast.success(response.message, { theme: "light" });
        setLikeDislikeCounts((prevCounts) => ({
          ...prevCounts,
          [commentid]: {
            likeCount: response.data.likeCount,
            disLikeCount: response.data.disLikeCount,
          },
        }));
      }
    } else {
      toast.warn(" نظر شما قبلا ثبت شده", { theme: "light" });
    }
  };

  return (
    <div>
      <CommentScore amusementService={amusementService} />
      {testimonials.map((testimonial, index) => (
        <Card className="w-100 mb-3 shadow-sm rounded-4" key={index}>
          <Card.Body className="pb-0">
            <Row>
              <Col xs={8}>
                <div className="text-small small-svg text-muted ">
                  <IconUserCustomer fillColor="#444" />
                  <span className="">
                    {" " +
                      testimonial.name +
                      " " +
                      (testimonial.surname == null
                        ? ""
                        : testimonial.surname)}{" "}
                  </span>
                </div>
              </Col>
              {testimonial.totallyRank == 0 ? (
                <Col xs={4} className="text-end fs-085 text-muted">
                  {" "}
                </Col>
              ) : (
                <Col
                  xs={4}
                  className="text-end fs-08 d-flex text-muted align-items-center  justify-content-end"
                >
                  <div>
                    {testimonial.totallyRank == 1
                      ? "خیلی بد"
                      : testimonial.totallyRank == 2
                      ? "بد"
                      : testimonial.totallyRank == 3
                      ? "متوسط"
                      : testimonial.totallyRank == 4
                      ? "خوب"
                      : testimonial.totallyRank == 5
                      ? "عالی"
                      : "-"}
                  </div>
                  <Badge
                    bg={testimonial.totallyRank >= 3 ? "success" : "warning"}
                    className="fs-09 fw-normal ms-1 "
                  >
                    {testimonial.totallyRank}
                  </Badge>
                </Col>
              )}
            </Row>
            <p className="mt-3 text-black text-align-justify">
              {testimonial.text}
            </p>

            {testimonial?.children?.map((testimonialChild) => (
              <div className="border-top py-3" key={testimonialChild.id}>
                <div className="fw-bold text-danger">
                  <IconComment fillColor="#f80248" />
                  <span className="ps-1">{testimonialChild.name}</span>
                </div>
                <div className="pt-2 text-align-justify">
                  {testimonialChild.text}
                </div>
              </div>
            ))}
          </Card.Body>
          <Card.Footer className="bg-transparent border-top-0 text-xsmall text-muted rounded-4 fs-085">
            <Row>
              <Col>{testimonial.createdPersianTime} </Col>
              <Col className=" text-end d-flex justify-content-end">
                <div
                  className=" text-medium  cursor-pointer px-1"
                  onClick={fnLikeOrDislike(testimonial.id, "Up")}
                >
                  <IconLike fillColor="#09a463" />
                </div>
                <div className="me-2 fw-bold">
                  {likeDislikeCounts[testimonial.id]?.likeCount ||
                    testimonial.likeCount}
                </div>

                <div
                  className=" text-medium  cursor-pointer px-1"
                  onClick={fnLikeOrDislike(testimonial.id, "Down")}
                >
                  <IconDisLike fillColor="#f80248" />
                </div>
                <div className="fw-bold">
                  {likeDislikeCounts[testimonial.id]?.disLikeCount ||
                    testimonial.disLikeCount}
                </div>
              </Col>
            </Row>
          </Card.Footer>
        </Card>
      ))}
    </div>
  );
}

export default ModalCommentBox;
